export default function Pricing() {
  return (
    <section id="pricing" className="relative min-h-[600px] flex items-center justify-between overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/4ec5b2db9a0b52e0f3a1381129d5f384.jpg)'
        }}
      ></div>
      
      <div className="absolute inset-0 bg-black/50"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-24 py-32 flex items-center justify-between">
        <div>
          <h2 className="text-7xl font-bold text-white leading-tight mb-8">
            start browsing<br />
            securely<br />
            today
          </h2>
        </div>

        <div className="text-right">
          <p className="text-2xl font-light text-white mb-3 leading-relaxed">
            No credit card required
          </p>
          <p className="text-2xl font-light text-white leading-relaxed">
            Instant activation
          </p>
        </div>
      </div>

      <div className="absolute bottom-32 left-24 z-10">
        <a href="#contact" className="inline-flex items-center gap-4 px-12 py-5 bg-white text-gray-900 rounded-full text-lg font-semibold hover:shadow-2xl transition-all whitespace-nowrap cursor-pointer group">
          Get Started Free
          <div className="w-12 h-12 bg-gray-900 rounded-full flex items-center justify-center">
            <i className="ri-arrow-right-line text-white text-xl group-hover:translate-x-1 transition-transform"></i>
          </div>
        </a>
      </div>
    </section>
  );
}